import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { AppRoutes } from './Routes';
import EsaedroNavigationBar from './Components/EsaedroNavigationBar'
import { BrowserRouter } from 'react-router-dom';
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import LoggedContext from './BusinessObjects/LoggedContext'
import UserProfile from './Models/UserProfile';
const appInsights = new ApplicationInsights({ config: {
  instrumentationKey: '3759d2b0-c01c-466d-85ed-82a223cbbb8a'
  /* ...Other Configuration Options... */
} });

class LoggedComponent extends Component {
  state = {
    username : '',
    tokenAPI:'',
    userProfile:null,
    selectedItem:null,
    selectedMenuItem:null,
    setUserToken: (UserName:string,TokenAPI:string) => {
      this.setState({username: UserName, tokenAPI:TokenAPI})
    },
    setUserProfile:(user:UserProfile) => {
      this.setState({userProfile: user})
    },
    setSelectedItem:(item:any) => {
      this.setState({selectedItem: item})
    },
    setSelectedMenuItem:(item:any) => {
      this.setState({selectedMenuItem: item})
    }
    
  }
  
  render() {
      return <LoggedContext.Provider value={this.state}>
        {this.props.children}
      </LoggedContext.Provider>
    }
}
appInsights.loadAppInsights();

class App extends Component<any,any> {
  constructor(props:any)
  {
    super(props);

    
  }

  render() {

    return (      
      <LoggedComponent>
      <BrowserRouter basename="/AdminPortal">
        <EsaedroNavigationBar />
        <Container>
          {AppRoutes}
        </Container>
      </BrowserRouter>
      </LoggedComponent>
    );
  }
}

export default App;